export default function MoreButton({ onClick }) {
    return (
        <div className="my-3 text-center disable-copy">
            <div className="rounded-custom d-inline mx-auto border bg-light px-3 py-1 cursor-pointer font-sm w-100" onClick={onClick}>
                Muat lebih
            </div>
        </div>
    )
}